const ReceivedOfferAccept = ({ nextStep, cost }) => {


  return (
    <>
      <ul className="sell-card__info-price">
        <li className="sell-card__info-price-title">Information</li>
        <li className="sell-card__info-price-item">
          <span>Type</span>
          <span>Marketplace sale</span>
        </li>
        <li className="sell-card__info-price-item">
          <span>Amount Offered</span>
          <span>${cost} USD</span>
        </li>
        <li className="sell-card__info-price-item">
          <span>Marketplace Fee (5%)</span>
          <span>-${(cost * 0.05).toFixed(2)}</span>
        </li>
        <li className="sell-card__info-price-item">
          <span>Net amount to seller</span>
          <span>${(cost - cost * 0.05).toFixed(2)} USD</span>
        </li>
      </ul>
      <button className="sell-card__info-form-submit" onClick={() => nextStep('confirm-accept')}>Accept</button>
    </>
  )
}

export default ReceivedOfferAccept;
